import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('planejamento_acao', 'configuracao');

const configuracaoActions = {
  buscarCamposFiltro: { methods: 'GET', url: `${basePath}/campos/filtro` },
  buscarCamposGrid: { methods: 'GET', url: `${basePath}/campos/grid/{idTipoAcao}` },
  buscarConfigVigente: { methods: 'GET', url: `${basePath}/vigente/{idTipoAcao}` },
  buscarConfigSnapshot: { methods: 'GET', url: `${basePath}/snapshot/{idAcao}` },
};

export default resource => resource(`${basePath}`, {}, configuracaoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/planejamento-acao-configuracao.js